"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactProvider = require("@trycourier/react-provider");

var _react = require("react");

var _reducer = _interopRequireDefault(require("./reducer"));

var _usePreferencesActions = _interopRequireDefault(require("./use-preferences-actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var usePreferences = function usePreferences() {
  var _useCourier = (0, _reactProvider.useCourier)(),
      preferences = _useCourier.preferences;

  var actions = (0, _usePreferencesActions["default"])();
  (0, _react.useEffect)(function () {
    (0, _reactProvider.registerReducer)("preferences", _reducer["default"]);
  }, []);
  return _objectSpread(_objectSpread({}, preferences), actions);
};

var _default = usePreferences;
exports["default"] = _default;